import request from '@/utils/httpRequest'

// 比赛活动列表
export function getWorkList (query) {
  return request({
    url: 'api/works/front/web/collect/page',
    method: 'get',
    params: query
  })
}

// 比赛活动详情
export function getWorkDetail (id) {
  return request({
    url: '/api/works/front/web/collect/' + id,
    method: 'get'
  })
}

// 词典
export function getCdian (query) {
  return request({
    url: '/api/communal/web/dict/searchType',
    method: 'get',
    params: query
  })
}

//  投票
export function getToupiao (worksId, userId) {
  return request({
    url: `/api/works/front/${worksId}/${userId}`,
    method: 'post'
  })
}

// 添加作品(需要token)
export function addNewwork (query) {
  return request({
    url: '/api/works/front/add',
    method: 'post',
    data: query
  })
}

// 文件上传
export function uploads (query) {
  return request({
    url: '/api/file/uploads',
    method: 'post',
    // headers: {'Content-Type': 'multipart/form-data'},
    data: query
  })
}
export function upload (query) {
  return request({
    url: '/api/file/upload',
    method: 'post',
    // headers: {'Content-Type': 'multipart/form-data'},
    data: query
  })
}
//  获取作品列表页
export function getWorkItemList (query) {
  return request({
    url: '/api/works/front/web/wk/page',
    method: 'get',
    params: query
  })
}

// 获取作品详情页
export function getWorkItemDetail (id) {
  return request({
    url: '/api/works/front/web/wk/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/workCollect/index.js